export default __webpack_public_path__ + "ce57e404b13371d2f4b79181fd6a6d57.png";